import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ExternalLink, XCircle } from 'lucide-react';

function PaymentCancel() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appReturn = searchParams.get('app_return') === '1' && !Capacitor.isNativePlatform();

  const openCaddiePayApp = () => {
    const query = searchParams.toString();
    const targetPath = `payment/cancel${query ? `?${query}` : ''}`;
    const targetUrl = /android/i.test(window.navigator.userAgent)
      ? `intent://${targetPath}#Intent;scheme=app.caddiepay.mobile;package=app.caddiepay.mobile;S.browser_fallback_url=${encodeURIComponent(window.location.href)};end`
      : `app.caddiepay.mobile://${targetPath}`;

    window.location.href = targetUrl;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center border-0 shadow-lg" data-testid="payment-cancel-card">
        <CardHeader className="pb-2">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-10 h-10 text-amber-600" />
          </div>
          <CardTitle className="text-2xl text-slate-900">Payment Cancelled</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-slate-600">
            Your payment was cancelled. No money has been deducted from your account.
          </p>
          {appReturn ? (
            <Button onClick={openCaddiePayApp} className="w-full btn-primary" data-testid="open-app-btn">
              <ExternalLink className="w-4 h-4 mr-2" />
              Open CaddiePay
            </Button>
          ) : (
            <Button onClick={() => navigate('/dashboard')} className="w-full btn-primary" data-testid="back-to-dashboard-btn">
              Back to Dashboard
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default PaymentCancel;
